<button mat-raised-button color="accent"
        [disabled]="noteForm.invalid || noteForm.disabled || spinnerLoading" [class.spinner]="spinnerLoading">
  Adicionar
</button>
